import Country from "../models/Country";
import * as jsonCountries from "../../../data/countries";

export default class CountryService {
  public getCountries(): Country[] {
    const countries: Country[] = [];

    Object.keys(jsonCountries.countries).forEach(key => {
      countries.push(new Country(key, jsonCountries.countries[key]));
    });

    // Order by name alphabetically
    countries.sort((a, b) => a.name.localeCompare(b.name));

    return countries;
  }
}


// WEBPACK FOOTER //
// ./src/modules/shared/services/CountryService.tsx